import { api as ActionApi } from '@src/entities/Action/api';
import { api as ActionPathApi } from '@src/entities/ActionPath/api';
import { api as AlertApi } from '@src/entities/Alert/api';
import { api as CodeApi } from '@src/entities/Code/api';
import { api as CriteriaApi } from '@src/entities/Criteria/api';
import { api as EventApi } from '@src/entities/Event/api';
import { api as InitiativeApi } from '@src/entities/Initiative/api';
import { api as RiskRecordApi } from '@src/entities/RiskRecord/api';
import { api as SourceApi } from '@src/entities/Source/api';
import { api as TagApi } from '@src/entities/Tag/api';
import { api as UserApi } from '@src/entities/User/api';

import { requests as DefaultApi } from './requests';

export const apis = {
  Action: ActionApi,
  ActionPath: ActionPathApi,
  Alert: AlertApi,
  Code: CodeApi,
  Criteria: CriteriaApi,
  Default: DefaultApi,
  Event: EventApi,
  Initiative: InitiativeApi,
  RiskRecord: RiskRecordApi,
  Source: SourceApi,
  Tag: TagApi,
  User: UserApi,
};
